var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.showFileList')}},[_c('el-switch',{model:{value:(_vm.optionModel.showFileList),callback:function ($$v) {_vm.$set(_vm.optionModel, "showFileList", $$v)},expression:"optionModel.showFileList"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }